import {useEffect} from 'react'

import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useFetch from 'shared/model/useFetch'
import {ROLE_EXTERNAL_ADMIN} from 'shared/constant/lookup/role'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetTicketStatistics = (year) => {
	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [userRole] = useRoleCookie()

	const [, setAlert] = useAlertModalAtom()

	const request = () => {
		let selectedYear = null
		if (year) {
			const parsedYear = new Date(year).getFullYear()
			selectedYear = parsedYear
		}
		const rolePath = getApiRolePath(userRole)
		let url = `/${rolePath}/ticket-statistics/overview?timestamp=${Date.now()}${
			selectedYear ? `&year=${selectedYear}` : ''
		}`

		fetchRequest('GET', url)
	}

	useEffect(() => {
		request()
	}, [year])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			default:
				break
		}
	}, [fetchResult])

	return [fetchResult, isLoading, request]
}

export default useGetTicketStatistics
